import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';
import styles from '../../../assets/css/layoutMain/navbar/navbar.module.css';
import images from '../../../assets/images';
import Button from '../../../components/button/Button';
import { handleLogout } from '../../../store/ducks/AuthDuck';
import { useGetUserProfile } from '../../../hooks/api/useUserProfile';

const Navbar = () => {
    const { logoOrganization, nameOrganization, loadProfile } = useSelector(
        state => state.auth
    );

    const { data } = useGetUserProfile();
    console.log(data);
    const [showMenu, setShowMenu] = useState(false);
    const menuRef = useRef();
    const navitation = useNavigate();

    useEffect(() => {
        const handlerDropdown = event => {
            if (!menuRef?.current.contains(event.target)) {
                setShowMenu(false);
            }
        };

        document.addEventListener('mousedown', handlerDropdown);
        return () => document.removeEventListener('mousedown', handlerDropdown);
    });

    const dispatch = useDispatch();

    const setLogout = () => {
        setShowMenu(false);
        dispatch(handleLogout());
    };

    return (
        <>
            <header className={styles.header}>
                <div className={styles.navbarTop}>
                    <img src={images.campfireSocialLogo} alt="logo" />
                    <span className={styles.textLogo}>
                        International Camping Association
                    </span>
                </div>
                <nav className={styles.navbar}>
                    <div className={styles.navbar__left}>
                        <div className={styles.navbar__left_logo}>
                            {logoOrganization ? (
                                <>
                                    <img
                                        className={styles.navbarImgLogo}
                                        src={logoOrganization}
                                        alt="logo"
                                    />
                                    <span className={styles.textLogo}>
                                        {nameOrganization}
                                    </span>
                                </>
                            ) : (
                                <img
                                    className={styles.navbarImgLogoDefault}
                                    src={images.logo26}
                                    alt="logo"
                                />
                            )}
                        </div>
                        <div className={styles.navbar__movil_left}>
                            <img src={images.homeIcon} alt="" />
                        </div>
                    </div>

                    {loadProfile && (
                        <div className={styles.navbar__right}>
                            <div className={styles.navbar__wrapper}>
                                <a className={styles.navbar__link} href="#!">
                                    <img src={images.search} alt="" />
                                    Search
                                </a>
                                <a className={styles.navbar__link} href="#!">
                                    <img src={images.notification} alt="" />
                                    Notifications
                                </a>
                                <a className={styles.navbar__link} href="#!">
                                    <img src={images.message} alt="" />
                                    Messages
                                </a>

                                <div ref={menuRef} className={styles.action}>
                                    <button
                                        onClick={() => setShowMenu(!showMenu)}
                                        className={styles.btnDropDownOpen}>
                                        <img
                                            src={
                                                data?.profilePicture ||
                                                images.profile3
                                            }
                                            alt="userImg"
                                        />
                                        Profile
                                    </button>
                                    <div
                                        className={`${styles.menu} ${
                                            showMenu ? styles.show : ''
                                        }`}>
                                        <h3 className={styles.menu__title}>
                                            Profile
                                        </h3>

                                        <div
                                            className={
                                                styles.menu__btnChange_wrapper
                                            }>
                                            <button
                                                onClick={() =>
                                                    navitation('/home')
                                                }
                                                className={
                                                    styles.menu__btnChange
                                                }>
                                                <img
                                                    src={
                                                        data?.profilePicture ||
                                                        images.profile3
                                                    }
                                                    alt=""
                                                />
                                                <div
                                                    className={
                                                        styles.menu__btnChangeInfo
                                                    }>
                                                    <span
                                                        className={
                                                            styles.menu__btnChangeName
                                                        }>
                                                        {`${data?.name} ${data?.lastname}`}
                                                    </span>
                                                    <span
                                                        className={
                                                            styles.menu__btnChangeSubtitle
                                                        }>
                                                        {data?.company}
                                                    </span>
                                                </div>
                                            </button>

                                            <button
                                                onClick={() =>
                                                    navitation('/vendor')
                                                }
                                                className={
                                                    styles.menu__btnChange
                                                }>
                                                <img
                                                    src="https://previews.123rf.com/images/docer2000/docer20001404/docer2000140400112/27635572-hierba-verde-blur-patr%C3%B3n-de-textura-fondos-de-pantalla.jpg"
                                                    alt=""
                                                />
                                                <div
                                                    className={
                                                        styles.menu__btnChangeInfo
                                                    }>
                                                    <span
                                                        className={
                                                            styles.menu__btnChangeName
                                                        }>
                                                        Revitalize Industries
                                                    </span>
                                                </div>
                                            </button>
                                        </div>

                                        <ul>
                                            <li>
                                                <a href="#!">
                                                    <img
                                                        className="icon_a"
                                                        src={images.pencil}
                                                        alt="icon"
                                                    />
                                                    Edit Profile
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#!">
                                                    <img
                                                        src={images.settings}
                                                        alt="icon"
                                                    />
                                                    Settings
                                                </a>
                                            </li>
                                        </ul>

                                        <div className={styles.wrapper__switch}>
                                            <Button
                                                icon={images.iconSwitch}
                                                alignImg={'left'}
                                                fontSize="0.875rem"
                                                classs="btnMain"
                                                text="Switch Campfires"
                                                onClick={() =>
                                                    navitation('/join-campfire')
                                                }
                                            />
                                        </div>

                                        <div className={styles.logout}>
                                            <button
                                                onClick={setLogout}
                                                className={styles.logout__btn}>
                                                <img
                                                    src={images.logout}
                                                    alt="icon"
                                                />
                                                Logout
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className={styles.navbar__movil_right}>
                                <button>btn burger</button>
                            </div>
                        </div>
                    )}
                </nav>
            </header>
        </>
    );
};

export default Navbar;
